import React, { useState, useEffect } from 'react';
import { Workbox } from 'workbox-window';

const PWAUpdater = () => {
  const [showUpdate, setShowUpdate] = useState(false);
  const [wb, setWb] = useState(null);

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      const wbInstance = new Workbox('/service-worker.js');

      wbInstance.addEventListener('installed', (event) => {
        if (event.isUpdate) {
          setShowUpdate(true);
          setWb(wbInstance);
        }
      });

      wbInstance.register();
    }
  }, []);

  const handleUpdate = () => {
    if (wb) {
      wb.messageSkipWaiting();
      window.location.reload();
    }
  };

  if (!showUpdate) return null;

  return (
    <div className="pwa-update-prompt">
      <p>? �Nueva versi�n de KREAMUN disponible!</p>
      <button onClick={handleUpdate} className="btn-update">
        Actualizar ahora
      </button>
    </div>
  );
};

export default PWAUpdater;